/**
 * Returns two-character uppercase initials from a first and last name.
 * Used by avatar components across the app.
 */
export function getInitials(firstName: string, lastName: string): string {
  return `${firstName[0] ?? ''}${lastName[0] ?? ''}`.toUpperCase();
}

/**
 * Formats a month + day pair into a locale-aware short date string
 * (e.g. "Apr 1", "يناير 1") using the app's i18n translation keys.
 * Returns '—' for falsy inputs.
 */
export function formatMonthDay(
  month: number,
  day: number,
  t: (_key: string, _options?: Record<string, unknown>) => string,
): string {
  if (!month || !day) return '—';
  return t('monthDayPicker.dateFormat', { month: t(`monthDayPicker.months.${month}`), day });
}
